import { createApp } from "vue";

import LocationsDetail from "~/vue/LocationsDetail.vue";

// Main app
const locationsDetail = async () => {
	const app = createApp(LocationsDetail);
	return app.mount("#locations-detail");
};

// Execute async function
locationsDetail().then(() => {
	console.log();
});
